
// 门诊 / 健康档案 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */



/**
 * 
 * get 
 *  
 */

// 列表
export const docphrpage = (params) => {
    return request.get("/outpatient/docphr/page", { params })
}

// 居民健康档案-信息列表
export const docphrList = (params) => {
    return request.get("/outpatient/docphr/list", { params })
}

export const docphrStatics = (params) => {
    return request.get("/outpatient/docphr/statics", { params })
}



/*
 * 
 * DELETE 
 *   
 */   


// 暴露
export default{
	docphrpage,
}